export enum Role {
  ADMIN = "admin",
  USER = "user",
  BUSINESS = "business",
}

export enum RedirectPath {
  DASHBOARD = "/dashboard",
  LOGIN = "/login",
  COMPANY = "/user/company",
}

export enum ApiCode {
  UNAUTHORIZED = "401",
}
